import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import JobDetailsDescription from "./JobDetailsDescription";
import JobVacancyPost from "./JobVacancyPost";
import RightSideContent from "./RightSideContent";
import Section from "./Section";
import { useParams } from "react-router-dom";
import { get, post } from "../../../utils/apiUtil";
import ApplyFobJobModal from "../../../components/ApplyForJobModal";

const JobDetails = () => {
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [jobDetails, setJobDetails] = useState([]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const toggleModal = () => setIsModalOpen(!isModalOpen);
    const [selectedJob, setSelectedJob] = useState(null);

    const getJobDetails = async (id) => {
        setIsLoading(true);
        try {
            const response = await get('/get-job-details', { params: { jobID: id } });
            setJobDetails(response.data);
        } catch (error) {
            console.log(error)
            alert(error?.message || "Something went wrong.");
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getJobDetails(id);
    }, [id]);

    const handleApplyClick = (job) => {
        setSelectedJob(job);
        setIsModalOpen(true);
    };

    if (isLoading) return
    return (
        <React.Fragment>
            <Section />
            <section className="section">
                <Container>
                    <Row>
                        <Col lg={8}>
                            <JobDetailsDescription jobDetails={jobDetails} />
                            <JobVacancyPost onApplyClick={handleApplyClick} />
                        </Col>
                        <Col lg={4} className="mt-4 mt-lg-0">
                            <RightSideContent jobDetails={jobDetails} onApplyClick={handleApplyClick} />
                        </Col>
                    </Row>
                </Container>
            </section>
            <ApplyFobJobModal
                isOpen={isModalOpen}
                toggle={toggleModal}
                job={selectedJob}
            />
        </React.Fragment>
    );
};

export default JobDetails;
